<template>
    <div class="my-wallet-component">
        <div class="my-balance">
            <span>我的余额：{{myWallet.balance || 0}}元</span>
        </div>
    </div>
</template>


<script>
export default {
   
    data() {
        return {
            myWallet: {},
        }
    },
    methods: {
        getMyWallet() {
            this.postRequest('/df-wallet/wallet/getWallet')
            .then(res => {
                let data = res.data;
                if (data.code == 200) {
                    this.myWallet = data.data;
                }
            })
            .catch(err => {
                
            })
        }
        
    },
    mounted() {
        this.getMyWallet();
    },
}
</script>